export default "__VITE_ASSET__BAIEFlYS__"